import { useCallback, useState } from 'react';

const usePermissionsMediaDevices = () => {
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);

  const requestPermissions = useCallback(async (): Promise<boolean> => {
    // Necessary to get permissions for media devices
    // Web: once. Other platforms: each and every lifecycle.
    try {
      // Start stream to init devices list (necessary on some browsers)
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true,
      });

      // Stop stream
      mediaStream.getTracks().forEach(track => track.stop());

      // Enumerate devices
      const devices = await navigator.mediaDevices.enumerateDevices();
      setDevices(devices);
      return true;
    } catch (e) {
      console.error('Failed to request permissions for media devices', e);
      return false;
    }
  }, []);

  return { devices, requestPermissions };
};

export default usePermissionsMediaDevices;
